import { ReviewStars } from "@/components/ReviewStars";
import { useT } from "@/lib/i18n";
import { useProductRatings } from "@/lib/product-ratings";

/**
 * Sterren van DIT artikel — niet die van de winkel.
 *
 * Onder productkaarten en naast de productnaam stond eerst de [[src/components/KiyohBadge.tsx]]
 * met het winkelcijfer. Dat leest als "dit product is zo beoordeeld", terwijl het over de hele
 * webshop gaat: elk artikel kreeg zo dezelfde sterren, ook artikelen die nog nooit beoordeeld
 * zijn. Hier komt het cijfer uit de beoordelingen van dat ene artikel (Kiyoh-productreviews +
 * eigen goedgekeurde reviews via de nachtelijke sync).
 *
 * Heeft het artikel nog geen beoordelingen, dan verschijnt er NIETS. Liever geen sterren dan
 * geleende sterren — en Google rekent een aggregateRating die niet bij het product hoort aan als
 * misleidende structuurdata.
 */
export function ProductRatingBadge({ slug, size = 16 }: { slug: string; size?: number }) {
  const t = useT();
  const cijfers = useProductRatings();
  const r = cijfers[slug];
  if (!r) return null;
  return (
    <span className="inline-flex items-center gap-1" aria-label={`${r.average.toFixed(1)} ${t("van 5")} (${r.count})`}>
      <ReviewStars value={r.average} size={size} />
      <span className="text-sm font-medium text-primary-700">
        {r.count} {r.count === 1 ? t("review") : t("reviews")}
      </span>
    </span>
  );
}
